export default "__VITE_ASSET__BwqlhCr9__"